// ProfileContext.js
import React, { createContext, useState, useEffect } from 'react';
import axiosInstance from '../axiosConfig';
import { jwtDecode } from 'jwt-decode';

// Erstelle den Kontext
export const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [profileImage, setProfileImage] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const fetchUserProfile = () => {
      const token = localStorage.getItem('authToken');

      axiosInstance
        .get('/profile/user-profile', {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((response) => {
          if (response.data.profile) {
            setUserProfile(response.data.profile);
            setProfileImage(response.data.profile.profileImage);
            const decodedToken = jwtDecode(token);
            const userRole = decodedToken.role;
            setUserRole(userRole);
          }
        })
        .catch((error) => {
          console.error('Fehler beim Abrufen des Benutzerprofils:', error);
        });
    };

    fetchUserProfile();

    // 2) Reagieren, wenn Token erneuert wurde:
    const handleTokenRefreshed = () => {
      fetchUserProfile();
    };
    
    window.addEventListener('tokenRefreshed', handleTokenRefreshed);
    return () => {
      window.removeEventListener('tokenRefreshed', handleTokenRefreshed);
    };
  }, []);

  return (
    <ProfileContext.Provider value={{ profileImage, setProfileImage, userProfile, setUserProfile, userRole, setUserRole }}>
      {children}
    </ProfileContext.Provider>
  );
};
